import { render, staticRenderFns } from "./timeSleep.vue?vue&type=template&id=1eff3f6e&"
import script from "./timeSleep.vue?vue&type=script&lang=js&"
export * from "./timeSleep.vue?vue&type=script&lang=js&"
import style0 from "./timeSleep.vue?vue&type=style&index=0&id=1eff3f6e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports